import { IPromptService } from './IPromptService';
import { Prompt, PromptRequest, PromptResponse, PromptsResponse } from '../models/PromptTypes';
import EnvConfigHelper from '../../../helpers/envConfigHelper';
import { HTTPDataService } from '../../../services/HTTPDataService';

class PromptService extends HTTPDataService implements IPromptService {
    baseURL = EnvConfigHelper.get('api-base-url', '');

    constructor(public getAccessToken: () => Promise<string | undefined>) {
        super();
    }

    getPromptsByKey = async (key: string) => {
        try {
            return await this.getObjectArray<PromptsResponse, Prompt>(`api/prompt-mgmt/${key}/prompt`, 'prompts');
        } catch (e) {
            console.error('PromptService: getPrompts error', e);
            throw e;
        }
    };

    getAllPrompts = async () => {
        try {
            return await this.getObjectArray<PromptsResponse, Prompt>(`api/prompt-mgmt`, 'prompts');
        } catch (e) {
            console.error('PromptService: getPrompts error', e);
            throw e;
        }
    };

    getPrompt = async (key: string, promptKey: string) => {
        try {
            return await this.get<Prompt>(`api/prompt-mgmt/${key}/prompt/${promptKey}`);
        } catch (e) {
            console.error('PromptService: getPrompt error', e);
            throw e;
        }
    };

    deletePrompt = async (key: string, promptKey: string) => {
        try {
            return await this.delete<boolean>(`api/prompt-mgmt/${key}/prompt/${promptKey}`);
        } catch (e) {
            console.error('PromptService: deletePrompt error', e);
            throw e;
        }
    };

    createPrompt = async (key: string, prompt: PromptRequest) => {
        try {
            return await this.post<Prompt>(`api/prompt-mgmt/${key}/prompt`, {}, prompt);
        } catch (e) {
            console.error('PromptService: createPrompt error', e);
            throw e;
        }
    };

    updatePrompt = async (key: string, promptKey: string, prompt: PromptRequest) => {
        try {
            return await this.patch<PromptResponse<{}>>(`api/prompt-mgmt/${key}/prompt/${promptKey}`, {}, prompt);
        } catch (e) {
            console.error('PromptService: updatePrompt error', e);
            throw e;
        }
    };

    copyPrompt = async (key: string, promptKey: string, prompt: PromptRequest) => {
        try {
            return await this.post<PromptResponse<Prompt>>(`api/prompt-mgmt/${key}/prompt/${promptKey}/copy`, {}, prompt);
        } catch (e) {
            console.error('PromptService: copyPrompt error', e);
            throw e;
        }
    };
}

export default PromptService;